define('base/reqres',['require','exports','module','base/class','underscore'],function(require, exports, module) {
  "use strict";

  var Class = require("base/class"),
      _ = require("underscore");

  module.exports = Class.extend({
    initialize: function() {
      this._handlers = {};
    },
    registerHandler: function(name, fn, context) {
      var config = {
        callback: fn,
        context: context
      };
      this._handlers[name] = config;
    },
    registerHandlers: function(handlers) {
      _.each(handlers, function(config, name) {
        this.registerHandler(name, config.callback, config.context);
      }, this);
    },
    requestCallback: function(name, cb) {
      var handler = this._handlers[name];
      if (handler)
        handler(cb);
    },
    request: function(){
      var handlerCfg = this._handlers[arguments[0]],
          args = Array.prototype.slice.call(arguments,1);

      if(handlerCfg){
        return handlerCfg.callback.apply(handlerCfg.context, args);
      }
    }
  });

});

